import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";

@Form({title: "Link View Config"})
export default class LinkViewConfig {

	@Input({type: InputType.PADDING, title: "Padding"})
	public padding: string = "0px 0px 0px 0px";

	@Input({type: InputType.BORDER, title: "Separator"})
	public separator: string = "0px 0px 0px 0px";

	@Input({type: InputType.COLOR, title: "Text Color"})
	public color: string;

	@Input({type: InputType.COLOR, title: "Text Active Color"})
	public activeColor: string;

	@Input({type: InputType.COLOR, title: "Text Hover Color"})
	public hoverColor: string;

	@Input({type: InputType.TEXT_TRANSFORM, title: "Text Transform"})
	public textTransform: string;

	@Input({type: InputType.FONT_WEIGHT, title: "Font Weight"})
	public fontWeight: string = "normal";

	@Input({type: InputType.CHECKBOX, title: "Show Label"})
	public showLabel: boolean = true;

	@Input({type: InputType.UNIT, title: "Label Size"})
	public labelSize: string;

	@Input({type: InputType.CHECKBOX, title: "Show Icon"})
	public showIcon: boolean = true;

	@Input({type: InputType.NUMBER, title: "Icon Size"})
	public iconSize: number;

	@Input({type: InputType.CHECKBOX, title: "Show Tooltip"})
	public showTooltip: boolean = false;

	@Input({type: InputType.COLOR, title: "Active Background Color"})
	public activeBackground: string;

	@Input({type: InputType.BORDER, title: "Active Border Color"})
	public activeBorder: string;

}



// WEBPACK FOOTER //
// ./src/common/views/menu/LinkViewConfig.ts